import React, { useState } from "react";
import api from "../../../services/baseUrl";

const LoginDetails = ({ formData, setFormData, prevStep, submitForm }) => {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [e.target.name]: "",
    }));
  };

  const isValidPassword = (password) => {
    // Check for non-blank printable characters
    if (!password || password.length < 9) {
      return false;
    }

    // Flags for the criteria
    let hasUpperCase = false;
    let hasLowerCase = false;
    let hasNumber = false;
    let hasSpecialChar = false;

    // Loop through each character to check for the criteria
    for (let char of password) {
      if (/[A-Z]/.test(char)) hasUpperCase = true;
      if (/[a-z]/.test(char)) hasLowerCase = true;
      if (/\d/.test(char)) hasNumber = true;
      if (/[!@#$%^&*(),.?":{}|<>]/.test(char)) hasSpecialChar = true;
    }
    
    // Count how many criteria are satisfied
    const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length;

    console.log(criteriaMet);
    // Check if at least 3 out of 4 criteria are met
    if (criteriaMet >= 3) {
      return true;
    } else {
      return false;
    }
  };
  const validateForm = () => {
    let formErrors = {};
    if (!formData.username) formErrors.username = "Username is required";
    if (!formData.password) formErrors.password = "Password is required";

    if (!isValidPassword(formData.password)) {
      formErrors.password =
        "Minimum 9 non-blank printable characters";
    }
    if (!formData.confirmPassword)
      formErrors.confirmPassword = "Password Confirmation is required";

    if (
      isValidPassword(formData.password) &&
      formData.password !== formData.confirmPassword
    ) {
      // formErrors.password = "Passwords do not match";
      formErrors.confirmPassword = "Password and Confirm Password do not match";
    }
    console.log(formErrors);
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // Return true if no errors
    // return false;
  };

  const [errors, setErrors] = useState({
    username: "",
    password: "",
    confirmPassword: "",
  });

  const validateUsername = async () => {
    try {
      const response = await api.get(`/user/usernameExists`, {
        params: { username: formData.username }, // Pass email as query param
      });

      // If the response is OK, return true
      if (response.status === 200) {
        return true;
      }
    } catch (err) {
      if (err.response && err.response.status === 400) {
        // Set the email error to the response body
        setErrors((prevErrors) => ({
          ...prevErrors,
          username: err.response.data, // Use the response body as the error message
        }));
      }
      return false;
    }
  };

  const handleSubmit = async () => {
    if (validateForm()) {
      const isUsernameValid = await validateUsername();
      if (isUsernameValid) {
        submitForm();
      }
    }
  };

  return (
    <>
      <button
        className="register1-button back-btn"
        type="button"
        onClick={prevStep}
      >
        Back
      </button>
      <h1>Create An Account</h1>
      <h2>Step&nbsp;3:&nbsp;Login&nbsp;Details</h2>

      <form className="register1-form">
        <div>
          <div className="dialog-input-field">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
            />
          </div>
          {errors.username && (
            <span className="form-error">{errors.username}</span>
          )}

          <div className="dialog-input-field">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
            {errors.password && (
              <p  className="form-error">
                <p>Password should be minimum 9 non-blank printable characters</p>
                <p>
                  It should also comply to 3 out of 4 of the following criteria:<br/>
                  ■ Should contain English Upper Case<br/>
                  ■ Should contain English Lower Case<br/>
                  ■ Numeric Characters (0 to 9)<br/>
                  ■ Special (printable) characters<br/>
                </p>
              </p>
            )}
          </div>

          <div className="dialog-input-field">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
            />
            {errors.confirmPassword && (
              <span className="form-error">{errors.confirmPassword}</span>
            )}
          </div>
          <button
            className="register1-button"
            type="button"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </form>
    </>
  );
};

export default LoginDetails;
